import React from "react";
import styles from "./Servies.module.css";
import image1 from "../../Images/noimage.jpeg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Spinner from "react-bootstrap/Spinner";
import OFF from "../../Images/OFF.svg";

const Servies = ({ onCardClick }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const { Services, loading } = useSelector((state) => state.ServicesSlice);

  console.log("Services", Services);

  const onSubmit = (card) => {
    sessionStorage.removeItem("cartFromCart");
    sessionStorage.removeItem("isEditServisePreducer");
    navigate("/details", { state: { cardData: card } });
    console.log("card", card);
    localStorage.setItem("ServicesCard", JSON.stringify(card));
  };

  return (
    <>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spinner
            animation="border"
            role="status"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
      ) : (
        <div>
          {Services && Services?.length > 0 ? (
            <div className={styles.cardContainer}>
              {Services &&
                Services?.map((card, index) => (
                  <div
                    key={index}
                    className={styles.card}
                    onClick={() => {
                      onSubmit(card);
                    }}
                    style={{
                      cursor: card.itm_typsal === 0 ? "not-allowed" : "pointer",
                    }}
                  >
                  {card?.itm_dessal*100 > 0 &&  <div
                      className={styles.offBadge}
                      style={{
                        right: currentLanguage === "ar" ? "auto" : "5px",
                        left: currentLanguage === "ar" ? "5px" : "auto",
                      }}
                    >
                      <img
                        src={OFF}
                        alt="Discount"
                        className={styles.offImage}
                      />
                      <div className={styles.offText}>
                      <div>{card?.itm_dessal*100}%</div>
                      <div>OFF</div>
                      </div>
                    </div>}
                    <img
                    src={(card?.itm_IMG && card?.itm_IMG?.trim() !="" ) ? `https://reservation.ladycaresa.com/public/uploads${card.itm_IMG}` : image1}
                      alt={card.itm_nam}
                      className={styles.cardImage}
                    />
                    <div className={styles.cardLabel}>
                      <span className={styles.cardName}>
                        {
                          currentLanguage === "ar"
                            ? card.itm_nam.trim() // Arabic branch name
                            : card.itm_enm.trim() || card.itm_nam.trim() // English branch name (fallback to Arabic if empty)
                        }
                      </span>
                      <span style={{ textAlign: "end" }}>
                        {card?.prcandtax.toFixed(2)}
                      </span>
                    </div>
                    {/* Tooltip */}
                    <div
                      className={styles.tooltip}
                      style={{
                        display: card.itm_typsal === 0 ? "block" : "none",
                      }}
                    >
                      {t("service_unavailable")}
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "28px",
                fontWeight: "900",
                margin: "70px",
              }}
            >
              {t("ThereAreNoServiesAvailableInThisCategory")}{" "}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Servies;
